import Responsive from './Responsive';
import IScroll from 'iscroll';

class SpNavi{
	constructor(param) {
		this.touches = typeof document.ontouchstart != "undefined",
		this.target = param.target;
		this.trigger = param.trigger;
		this.filter = param.filter;
		this.speed = param.speed;
		this.scroll;
		this.fixer = param.fixer;
	}

	exec(){
		const [target,_touches] = [this.target , this.touches];
		let th = 0;

		//set click event
		$(this.trigger).on('click',function(ev){
			ev.preventDefault();

			//set height
			if (_touches) {
				th = window.innerHeight;
			}else{
				th = $(window).height();
			}

			$(target).height(th).find('#scroller > ul').css({'padding-bottom':this.fixer});//

			let status = $(target).hasClass('to_left');

			if(status){
				$(target).removeClass('to_left');
				//$(target).fadeOut(this.speed);
				$(this.filter).removeClass('to_left');
				$(window).off("touchmove._noscroll");
				$(this).removeClass('active');
			}else{
				$(target).addClass('to_left');
				//$(target).fadeIn(this.speed*2);
				$(this.filter).addClass('to_left');
				let Scroll = new IScroll(target, {
					mouseWheel:true,
					preventDefault: false
				});
				if(_touches){
					$(window).on("touchmove._noscroll" , function(event) {
						event.preventDefault();
					});
				}
				$(this).addClass('active');
			}
		});

		const r = new Responsive();

		$(window).on('load resize',function(){
			if(r.state()() === false){
				$(target).hide();
			}
		});

	}
}
module.exports = SpNavi;



// WEBPACK FOOTER //
// ./dev/js/scripts/SpNavi.js